import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countriesSelect"]

  handleChange({ target }) {
    const makeId = target.value

    if (!makeId) {
      const tom = this.countriesSelectTarget?.tomselect
      if (tom) {
        tom.clear?.()
        tom.clearOptions?.()
        tom.disable?.()
      } else {
        this.countriesSelectTarget.innerHTML = ""
        this.countriesSelectTarget.disabled = true
      }
      return
    }

    fetch(`/admin/car_makes/${makeId}/available_countries`)
      .then((res) => res.text())
      .then((html) => {
        document.getElementById("countries_select_frame").innerHTML = html
      })
  }
}